export const COURSE_DEPARTMENTS = ['CSE', 'CSE(AIML)', 'IT', 'EEE', 'ECE'];

export const COURSE_YEARS = [1, 2, 3, 4];
export const COURSE_SEMESTERS = [1, 2];

const ROMAN_MAP = {
  1: 'I',
  2: 'II',
  3: 'III',
  4: 'IV'
};

export const toRoman = (n) => ROMAN_MAP[n] || String(n);
